export const API_URL = process.env.REACT_APP_API_URL;
export const RIDER_API_URL = process.env.REACT_APP_RIDER_URL;